
var kvAnim = {
	bgScale:0,
	ease:'easeInOutCubic',
	copy_step:0,
	init:function(){
		var t=this;
		t.bgScale = 1.5;

		// $('.product_kv_bg').stop().velocity('stop').velocity({scale:1.6,opacity:0,translateX:'-10%'},1);
		$('.main_ci').stop().velocity('stop').velocity({opacity:0},1);
		$('.main_sholder').stop().velocity('stop').velocity({opacity:0},1);
		$('.main_ttl').stop().velocity('stop').velocity({opacity:0},1);
		$('.watch_the_video').stop().velocity('stop').velocity({opacity:0},1);
		$('.release_date').stop().velocity('stop').velocity({opacity:0},1);

		$('.kv_scrl_block').each(function(i,elm){
			kvAnim.copyInit($(elm));
		});
		// $('.fv_area').stop().velocity('stop').velocity({top:'53%',translateY:'-50%',translateX:'-50%'},{duration:0});
		

		//Indicator
		$('.product_kv').append('<ul id="kv_indi"></ul>');

		$('.kv_scrl_block').each(function(i,elm){
			let dom = '';
			dom += '<li><a href="#kv-block0'+i+'" class="indi_'+i+'" data-num="'+i+'"></a></li>';
			$('#kv_indi').append(dom);

		});

		videoTab.init();
		changeImg.init();

	},
	show:function(){
		var t = this;
		$('.product_kv_bg').removeClass('step0').addClass('show');
		$('.kv_ex').addClass('show');
		// $('.product_kv_bg').stop().velocity('stop').velocity({blur:'0',scale:1,opacity:1,translateX:0},{duration:1400,delay:500,easing:'easeOutCubic'});
		$('.main_ci').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:1500});
		$('.main_sholder').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2000});
		$('.main_ttl').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2500});
		$('.watch_the_video').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3000});
		$('.release_date').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3500});
	},
	step0:function(){
		var t = this;
		let spd = 750;
		let dly = 250;
		t.copy_step=0;
		$('.kv_ex').addClass('show');
		$('.product_kv_bg').removeClass('show').removeClass('step1').addClass('step0');
		$('.fv_area').removeClass('show').removeClass('step1').addClass('step0');
		$('.fv_area2').removeClass('show').removeClass('step1').addClass('step0'); //230803池上追加
		// $('.product_kv_bg').stop().velocity('stop').velocity({blur:'0',scale:1,opacity:1,translateX:0},{duration:spd,delay:dly,easing:t.ease});
		// $('.fv_area').stop().velocity('stop').velocity({top:'53%',translateY:'-50%',translateX:'-50%'},{duration:spd,delay:dly,easing:t.ease});
		$('.main_ci').stop().velocity('stop').velocity({translateY:0,opacity:1},{duration:spd*1.4,delay:dly});
		$('.main_sholder').stop().velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly});
		$('.main_ttl').stop().velocity('stop').velocity({scale:1,opacity:1},{duration:spd,delay:dly});
		$('.watch_the_video').stop().velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly});
		$('.release_date').stop().velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly});

	},
	step1:function(){
		var t = this;
		let spd = 1000;
		t.copy_step=1;
		
		let target_x = (cmn_mode == "sp")? '-50%':'-4%';
		// let target_x = '0%';
		let target_y = (cmn_mode == "sp")? '30%':'45%';
		$('.kv_ex').removeClass('show');
		$('.product_kv_bg').removeClass('show').removeClass('step0').addClass('step1');
		$('.fv_area').removeClass('show').removeClass('step0').removeClass('step99').addClass('step1');
		$('.fv_area2').removeClass('show').removeClass('step0').removeClass('step99').addClass('step1'); //230803池上追加
		// $('.product_kv_bg').stop().velocity('stop').velocity({scale:1.2,blur:'5px',opacity:0.5,translateX:'-10%'},{duration:1000,delay:0,easing:t.ease});
		// $('.fv_area').stop().velocity('stop').velocity({top:target_y,translateY:'-80%',translateX:target_x},{duration:spd,delay:0,easing:t.ease});
		$('.main_ci').stop().velocity('stop').velocity({translateY:'-180%',opacity:0},{duration:spd*0.5,delay:0,easing:'ease-in'});
		$('.main_sholder').stop().velocity('stop').velocity({translateY:'-145%',opacity:0},{duration:spd,delay:0,easing:'linear'});
		$('.main_ttl').stop().velocity('stop').velocity({scale:.5,opacity:1},{duration:spd,delay:0,easing:t.ease});
		$('.watch_the_video').stop().velocity('stop').velocity({translateY:'150%',opacity:0},{duration:spd,delay:0,easing:'linear'});
		$('.release_date').stop().velocity('stop').velocity({translateY:'200%',opacity:0},{duration:spd,delay:0,easing:'linear'});
	},
	step99:function(step_flg){
		var t = this;
		let spd = 500;
		let target_x = (cmn_mode == "sp")? '-50%':'0%';
		let opt = step_flg? 1 :0;

		$('.fv_area').addClass('step99');
  		$('.fv_area2').addClass('step99'); //230803池上追加

		// $('.fv_area').velocity({opacity:opt,translateY:'-80%',translateX:target_x},spd);
	},
	copyInit:function($block){
		let $tag = $block.find('.kv_copy_area');

		$tag.find('.ttl').velocity('stop').velocity({scale:1.8,opacity:0,translateY:'0px'},{duration:0,delay:0});
		$tag.find('.desc').velocity('stop').velocity({translateY:'100px',opacity:0},{duration:0,delay:0});
		$tag.find('.sml').velocity('stop').velocity({translateY:'180px',opacity:0},{duration:0,delay:0});
		$tag.hide();
	},
	copyStep:function($block,num){
		var t = this;
		let spd = 750;
		let dly = (t.copy_step > 0)? 500 : 1000;
		t.copy_step = num + 2;

		let $tag = $block.find('.kv_copy_area');

		t.copyInit($block);
		$block.addClass('go');
		$tag.show();
		$tag.find('.ttl').stop(false,true).velocity('stop').velocity({scale:1,opacity:1},{duration:spd,delay:dly,easing:t.ease});
		$tag.find('.desc').stop(false,true).velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly,easing:t.ease});
		$tag.find('.sml').stop(false,true).velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly,easing:t.ease});

		$('#kv_indi li a.indi_'+num).addClass('active');

	},
	leave:function(){
		var t = this;
		let spd = 500;
		let $block = $('.kv_scrl_block.go');
		let $tag = $block.find('.kv_copy_area');
		$tag.find('.ttl').velocity('stop').velocity({opacity:0,translateY:'-100px',scale:1},{duration:spd,delay:0,easing:t.ease});
		$tag.find('.desc').velocity('stop').velocity({opacity:0,translateY:'-100px'},{duration:spd,delay:100,easing:t.ease,complete:function(){
			t.copyInit($block);
		}});
		$tag.find('.sml').velocity('stop').velocity({opacity:0,translateY:'-100px',scale:1},{duration:spd,delay:200,easing:t.ease});

		$('.fv_area').removeClass('step99');
		$('.fv_area2').removeClass('step99'); //230803池上追加
        $block.removeClass('go');

		$('#kv_indi li a.active').removeClass('active');
	}
}

var videoTab = {
	$tab:null,
	$video:null,
	init:function(){
		let t = this;

		t.$tab = $('.tab_menu');
		t.$video = $('.video_area');

		t.$tab.find('li a').click(function(){
			let num = $(this).attr('data-movie');
			t.change(num);
			return false;
		})
	},
	change:function(num){
		this.$tab.find('li a').removeClass('active');
		this.$tab.find('li a').eq(num-1).addClass('active');

		this.$video.find('li').removeClass('active');
		this.$video.find('li').eq(num-1).addClass('active');
		this.$video.find('li video').get(0).pause();
		this.$video.find('li video').eq(num-1).get(0).play();
	}
}

var changeImg = {
	status:'day',
	init:function(){
		$('.switcher-part').click(function(){
			changeImg.switch();
		})
	},
	switch:function(){
		let $tag = $('#kaihiritsu2 .func_bg_area');
		if(!$tag.hasClass('night-mode')){
			$tag.addClass('night-mode');
		}else{
			$tag.removeClass('night-mode');
		}
	}
}